export default __webpack_public_path__ + "static/media/2.2f4424e0.png";